import $ from 'jquery';

$(function() {

    // Open Modal
    $('.js-modal-open').on('click', function() {
        $('.js-modal').addClass('active');
    });

    // Close Modal
    $('.js-modal-close').on('click', function() {
        $(this).parents('.modal').removeClass('active');
    });

});